import React, { Component } from 'react';
import PropTypes from 'prop-types';
import anime from 'animejs';
import _ from 'underscore';
import $ from 'jquery';

import Card from './Card';

// intit carousel
const carousel = () => {
  const $slideWrap = $('.carousel-news-events > .slide-wrap');
  const container = '.carousel-news-events';
  const $initSlides = $slideWrap.html();
  const slides = document.querySelectorAll('.carousel-news-events > .slide-wrap > .slide');
  let sliderWidth = 0;
  let animationWidth = 0;

  const $firstSlide = $('.carousel-news-events > .slide-wrap > .slide:first-child');
  const $allSlides = $('.carousel-news-events > .slide-wrap > .slide');

	$allSlides.each(function(){
		animationWidth += $(this).outerWidth(false);
	});

	// detect number of visible slides
	let slidesVisible = $(container).width() / $firstSlide.outerWidth(false);
	slidesVisible = Math.ceil(slidesVisible);

  // append the tail
  $allSlides.slice(0).clone().appendTo($slideWrap);

	// Detect the slider width with appended tail
  $allSlides.each(function(){
		sliderWidth += $(this).outerWidth(false);
  });

  // count slides to determine animation speed
	const slidesNumber = $('.carousel-news-events > .slide-wrap > .slide').length;
	var speed = slidesNumber*2000;

	// set slider dimensions
	$slideWrap.css('width', sliderWidth);

  // Animation
  const slideScroll = anime({
    targets: slides[0],
    marginLeft: -animationWidth,
    duration: speed,
    autoplay: false,
    easing: 'linear',
    loop: true,
  });

// handle window resize + orientation change
const handleCarousel = () => {
  $slideWrap.removeAttr('style').empty().html($initSlides);
  const slidesB = document.querySelectorAll('.carousel-news-events > .slide-wrap > .slide');
  carousel(container, slidesB);
}

  $allSlides.removeAttr('style');
  slideScroll.play();

  $(container).on('mouseenter', '.card', slideScroll.pause );
  $(container).on('mouseleave', '.card', slideScroll.play );

  let lastWidth = $(window).width();

  $(window).resize(_.debounce(() => {
    const currentWidth = $(window).width();

    // only called when the window width changes
    if (currentWidth !== lastWidth) {
      lastWidth = $(window).width();

      handleCarousel();
    }
  }, 300));
}

const formatDate = (string, format) => {
  const date = new Date(string);
  let options = { month: 'short', year: 'numeric' };
  if (format === 'MYD') {
    options = { month: 'short', day: '2-digit', year: 'numeric' };
  }

  const formatedDate = date.toLocaleDateString('en-US', options).replace(',', '');
  return formatedDate;
};

export default class NewsEventsCarouselSlides extends Component {

  render() {
    const {
      terms, data, page, ready,
    } = this.props;

    const getTerm = (tid) => {
      let termName = '';
      terms.forEach((term, i) => {
        if (term.tid === `${tid}`) {
          termName = terms[i].name;
        }
      });
      return termName;
    };

    const childElements = () => data.map((card, i) => {
      if (data.length === i + 1) {
        setTimeout(() => {
          carousel();
        }, 500);
      }
      return (
        <div className="slide" key={`slide-${card.nid[0].value}`}>
          <Card
            key={card.nid[0].value}
            type={typeof card.type[0] === 'undefined' ? '' : card.type[0].target_id}
            theme={typeof card.field_theme[0] === 'undefined' ? '' : getTerm(card.field_theme[0].target_id)}
            fieldType={typeof card.field_type[0] === 'undefined' ? '' : getTerm(card.field_type[0].target_id)}
            color={typeof card.field_header_background[0] === 'undefined' ? '' : card.field_header_background[0].color}
            image={card.field_header_image instanceof Array || typeof card.field_header_image === 'undefined' ? 'https://via.placeholder.com/370x480.png' : card.field_header_image}
            newsTitle={!card.field_news_title || typeof card.field_news_title[0] === 'undefined' ? '' : card.field_news_title[0].value}
            title={typeof card.title[0].value === 'undefined' ? '' : card.title[0].value}
            date={typeof card.published_at[0] === 'undefined' ? '' : formatDate(card.published_at[0].value)}
            alumnus={typeof card.alumni === 'undefined' ? {} : card.alumni}
            url={`${card.path[0].alias}`}
            featured={typeof card.sticky[0] === 'undefined' ? '' : card.sticky[0].value}
            intro={typeof card.field_intro_paragraph_wysiwyg[0] === 'undefined' ? '' : card.field_intro_paragraph_wysiwyg[0].value}
            description={typeof card.field_description[0] === 'undefined' ? '' : card.field_description[0].value}
            eventStartDate={!card.field_event_start_date || typeof card.field_event_start_date[0] === 'undefined' ? '' : card.field_event_start_date}
            eventEndDate={!card.field_event_end_date || typeof card.field_event_end_date[0] === 'undefined' ? '' : card.field_event_end_date}
            eventSubType={!card.field_event_subtype || typeof card.field_event_subtype[0] === 'undefined' ? '' : getTerm(card.field_event_subtype[0].target_id)}
            newsSubType={!card.field_news_subtype || typeof card.field_news_subtype[0] === 'undefined' ? '' : getTerm(card.field_news_subtype[0].target_id)}
          />
        </div>
      );
    });

    if (!ready) return <div />;

    return childElements();
  }
}

NewsEventsCarouselSlides.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.object,
  ).isRequired,
  terms: PropTypes.arrayOf(
    PropTypes.object,
  ).isRequired,
};
